/**
 * Registers the global delegated click handler for data-lightbox anchors.
 * Call once after the app mounts.
 */
import { LIGHTBOX_TRIGGER_SELECTOR } from "./lightboxContract";
import { openLightbox } from "./useLightbox";

const LIGHTBOX_IGNORE_SELECTOR = "[data-lightbox-ignore]";

function handleDocumentClick(e: MouseEvent) {
  const target = e.target;
  if (!(target instanceof HTMLElement)) return;

  const anchor = target.closest(LIGHTBOX_TRIGGER_SELECTOR) as HTMLAnchorElement | null;
  if (!anchor) return;
  // Allow nested controls (or the anchor itself) to opt out of delegated lightbox open behavior.
  if (target.closest(LIGHTBOX_IGNORE_SELECTOR)) return;

  const opened = openLightbox(anchor);
  if (opened) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
  }
}

export function initLightbox(): void {
  document.addEventListener("click", handleDocumentClick, true);
}
